export function farloUiRevolverFlickityCarousel(element) {
	const elementsInView = 3 || 1.2;

	const getNumVisibleCells = () => {
		return window.innerWidth <= 992 ? 1.2 : elementsInView;
	};

	let flkty = new Flickity(element, {
		cellAlign: 'center',
		pageDots: false,
		prevNextButtons: false,
		wrapAround: true,
		groupCells: true,
		autoPlay: true,
		dragThreshold: 1,
		draggable: true,
	});

	const onResize = () => {
		if (!flkty || !flkty.options) {
			return;
		}

		const newVisibleCells = getNumVisibleCells();
		if (flkty.options.groupCells !== newVisibleCells) {
			flkty.options.groupCells = newVisibleCells;
			flkty.destroy();
			flkty = new Flickity(element, {
				cellAlign: 'center',
				pageDots: false,
				prevNextButtons: false,
				wrapAround: true,
				groupCells: newVisibleCells,
				draggable: true,
				dragThreshold: 1,
			});
		}
	};

	window.addEventListener('resize', onResize);
}
